export default __webpack_public_path__ + "static/ely-1-a8b2e1a527afc0ec853c01c0b90b7a92.jpg";